import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { intlShape } from 'react-intl';
import styled from 'styled-components';

import {
  getShopDetailsSearchRoute,
  getShopReviewsRoute,
  ROUTES,
} from '@services/routes.service';
import MagicHeader from '@components/MagicHeader';
import FixedHeader from '@components/FixedHeader';
import MenuSearchInput from '@conversion/containers/MenuSearchInput';
import { calculateOpacities } from '@shopDetails/utils/headerOpacities';
import useIsDesktopLayout from '@hooks/useIsDesktopLayout';
import BrandHeader from '../components/BrandHeader';
import MainHeaderGroceries from '../components/MainHeaderGroceries/Loadable';
import messages from './messages';

const MenuSearchInputContainer = styled.div`
  width: 100%;
  display: flex;
  margin: ${({ theme }) => theme.spacing(2, 6, 0, 6)};
`;

function ShelvesMenuHeader({
  shop,
  pushPage,
  goBack,
  trackProductSearchClicked,
  match: {
    params: { city, restaurant },
  },
  subHeader,
  goTo,
  intl: { formatMessage },
  show,
}) {
  const onSearchClick = useCallback(() => {
    pushPage(getShopDetailsSearchRoute({ city, restaurant }));
    trackProductSearchClicked();
  }, [pushPage, trackProductSearchClicked, city, restaurant]);

  const reviewsRoute = useMemo(
    () => getShopReviewsRoute({ city, restaurant }),
    [city, restaurant],
  );

  const isDesktopLayout = useIsDesktopLayout();

  return (
    <div show={show}>
      <BrandHeader goBack={goBack} goTo={goTo} showActions={isDesktopLayout} />
      <MagicHeader
        calculateOpacities={calculateOpacities}
        mainHeader={
          <MainHeaderGroceries
            shop={shop}
            reviewsRoute={reviewsRoute}
            onSearchClick={onSearchClick}
            searchPlaceholder={formatMessage(messages.searchInputPlaceholder)}
            subHeader={subHeader}
          />
        }
        secondHeader={
          <div>
            <FixedHeader
              onClose={goBack}
              label={isDesktopLayout ? shop?.name : ''}
              showLogo={!isDesktopLayout}
              shadow={isDesktopLayout}
            >
              <MenuSearchInputContainer>
                <MenuSearchInput
                  isHeader
                  disabled
                  onClick={onSearchClick}
                  placeholder={formatMessage(messages.searchInputPlaceholder)}
                />
              </MenuSearchInputContainer>
            </FixedHeader>
            {subHeader}
          </div>
        }
      />
    </div>
  );
}

ShelvesMenuHeader.propTypes = {
  shop: PropTypes.object.isRequired,
  pushPage: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  trackProductSearchClicked: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      city: PropTypes.string,
      restaurant: PropTypes.string,
    }),
  }).isRequired,
  subHeader: PropTypes.node,
  goTo: PropTypes.string,

  intl: intlShape.isRequired,
  show: PropTypes.bool,
};

ShelvesMenuHeader.defaultProps = {
  goTo: ROUTES.HOME,
  show: true,
};

export default ShelvesMenuHeader;
